import React, {Component, Fragment} from 'react';
import {NavLink} from 'react-router-dom'
import axios from "axios";
import {BASE_PATH} from "../../../../wpconfig";

class ScholarItem extends Component {
	constructor(props) {
		super(props);
	}

	handleFavoriteClick = async (record, isFavorite) => {
		const local_user_id = rmVars.scholar_id;
		if(local_user_id) {
			if (isFavorite) {
				// 관심 연구자 삭제 확인
				const confirmDelete = window.confirm("선호 연구자를 삭제하시겠습니까?");
				if (confirmDelete) {
					const url = `scholar_favorite/${local_user_id}/delete`; // DELETE URL
					const options = {
						method: 'GET',
						params: {favor_id: record.favor_id}, // 전달할 데이터
						headers: {
							'X-WP-Nonce': rmVars.api_nonce,
						},
						url: rmVars.restApi + url,
					};

					try {
						let response = null;
						await axios(options)
							.then((res) => {
								if (res.data.status) response = res.data.result;
							})
							.catch((error) => {
								console.error("삭제 중 오류 발생:", error);
							});

						if (response) {
							alert('삭제되었습니다.')
							// console.log("삭제 완료:", response);
							this.props.refreshList(); // 리스트 갱신
						}
					} catch (error) {
						console.error("API 호출 오류:", error);
					}
				}
			} else {
				// 관심 연구자 추가 확인
				const confirmAdd = window.confirm("선호 연구자로 추가하시겠습니까?");
				if (confirmAdd) {
					const url = `scholar_favorite/${local_user_id}/update`; // POST URL
					const options = {
						method: 'GET',
						params: {favor_scholar_id: record.scholar_id}, // 전달할 데이터
						headers: {
							'X-WP-Nonce': rmVars.api_nonce,
						},
						url: rmVars.restApi + url,
					};

					try {
						let response = null;
						await axios(options)
							.then((res) => {
								if (res.data.status) response = res.data.result;
							})
							.catch((error) => {
								console.error("추가 중 오류 발생:", error);
							});

						if (response) {
							alert('완료되었습니다.')
							// console.log("추가 완료:", response);
							this.props.refreshList(); // 리스트 갱신
						}
					} catch (error) {
						console.error("API 호출 오류:", error);
					}
				}
			}
		} else {
			alert('로그인후 이용해주세요.')
		}
	};

	render() {
		const record = this.props.record;

		const isFavorite = record.favor_id !== undefined && record.favor_id !== null;

		return (
			<div className="researcher-list-item">
				<div className="user-picture">
					<div className="thumb"><img src={rmVars.themeUrl + '/assets/images/user_picture.png'} alt=""/></div>
					<span
						className={`icon icon-size-24 ${isFavorite ? 'icon-user-favorite' : 'icon-user-no-favorite'}`}
						style={{ cursor: "pointer" }}
						onClick={() => this.handleFavoriteClick(record, isFavorite)}
					/>
				</div>
				<div className="item-info">
					<div className="item-info-inner">
						<NavLink to={BASE_PATH + "scholar/?record_id=" + record.scholar_id} className="item-name">
							{record.scholar_name}
						</NavLink>
						{rmVars.isEditor &&
							<a href={rmVars.homeUrl + "?page=scholar&record_id=" + record.scholar_id}
							   target="_blank"
							   className="ml-2"><span className="editor-edit"/></a>
						}
						<div className="item-cate">
							<strong>{record.sinbun_name}</strong>{record.col_name}{record.dept_name ? '·' + record.dept_name : ''}
						</div>
						<div className="item-tag">
							{record.research_field ? record.research_field :
							record.scholar_keyword && record.scholar_keyword.map((item, index) => {
								return (
									<Fragment key={index}>{item}{record.scholar_keyword.length - 1 > index ? ', ' : ''} </Fragment>
								)
							})}
						</div>
					</div>
				</div>
				<div className="item-value">발표논문 <strong className="color-lightblue">{record.resource_count}</strong></div>
			</div>
		)
	}
}

export default ScholarItem;
